module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    ref: "container",
    staticClass: ["container"]
  }, [_c('dof-mask', {
    on: {
      "click": _vm.layoutClick
    }
  }), _c('div', {
    staticClass: ["operate-box"]
  }, [_c('div', {
    staticClass: ["operate-box-item"],
    on: {
      "click": _vm.onDelete
    }
  }, [_c('text', {
    staticClass: ["operate-box-item-text"]
  }, [_vm._v(_vm._s(_vm.delTitle))])])])], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-563d30e4!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-operation-modal/index.vue
// module id = 607
// module chunks = 0 1